<template>
  <div>
    <van-notice-bar color="rgb(57, 118, 198)" background="#f5f7f9" left-icon="weapp-nav" :scrollable="false">
      共 {{total}} 条
    </van-notice-bar>
  </div>
</template>

<script>
import { NoticeBar } from 'vant'
export default {
  name: 'TotalComponent',
  props: ['totalValue'],
  data() {
    return {
      total: this.totalValue
    }
  },
  components: {
    [NoticeBar.name]: NoticeBar,
  }
}
</script>
<style lang="less">
  .van-notice-bar{
      // padding-top: 100px;
      height: 60px;
      // line-height: 60px;
  }
</style>